import React, { memo, useCallback } from "react";
import { Form } from "react-bootstrap";
import styles from "../../Tax.module.scss";

const ApplyTaxCheckboxGroup = memo(
  ({ taxState, values, onChange, disabled = false }) => {
    const handleChange = useCallback(
      (taxType) => (e) => {
        onChange(taxType, e.target.checked);
      },
      [onChange],
    );

    return (
      <div className={styles.formGroup}>
        <label className={styles.label}>
          Apply Applicable Taxes to One-Time Setup Fee
        </label>
        <div className={styles.checkboxGroup}>
          <Form.Check
            type="checkbox"
            label="State Tax"
            disabled={!taxState || disabled}
            checked={values.state}
            onChange={handleChange("state")}
            className={styles.checkboxLabel}
          />
          <Form.Check
            type="checkbox"
            label="County Tax"
            disabled={!taxState || disabled}
            checked={values.county}
            onChange={handleChange("county")}
            className={styles.checkboxLabel}
          />
          <Form.Check
            type="checkbox"
            label="Other Tax"
            disabled={!taxState || disabled}
            checked={values.other}
            onChange={handleChange("other")}
            className={styles.checkboxLabel}
          />
          <Form.Check
            type="checkbox"
            label="Use Tax"
            disabled={!taxState || disabled}
            checked={values.use}
            onChange={handleChange("use")}
            className={styles.checkboxLabel}
          />
        </div>
        {!taxState && (
          <span className={styles.helpText}>
            Please select a state first to enable these options
          </span>
        )}
      </div>
    );
  },
);

ApplyTaxCheckboxGroup.displayName = "ApplyTaxCheckboxGroup";

export default ApplyTaxCheckboxGroup;
